import axios from 'axios';

export default {
  name: 'history',
  data () {
    return {
      history: {},
    };
  },
  computed: {

  },
  mounted () {
    this.getHistory();
  },
  methods: {
    getHistory () {
      axios.post(this.$store.getters.rootAPI + '/error_category/get_history/' + this.$route.params.id).then((response) => {
        if (response.data.status == false) {
          return alert('Something goes wrong');
        } else {
          this.history = response.data.ListValue;
        }
      });
    },
  },
};
